import { useEffect, useState } from "react";
import { createDebounce } from "../../../../../common/helpers/debounce.helper";
import { getVehiclesByPartnerId } from "../../../../../common/services/vehicles.api";
import { IVehicle, VEHICLE_STATUS } from "../../../../../types/vehicle.type";
import AutocompleteFormik from "../../../../../common/components/form/AutocompleteFormik";
import { useFormikContext } from "formik";
import { filterVehiclesByPlan } from "../../../../../common/helpers/filter-vehicles-plan";
import { formatCompanyName } from "@/common/helpers/format-company-name";

const getVehiclesDebounced = createDebounce(getVehiclesByPartnerId, 100);

type Props = {
  required?: boolean;
  status?: VEHICLE_STATUS;
  notRented?: boolean;
  partnerId?: string;
  companyId: string;
  renterId?: string;
  plan?: string;
  listAll?: boolean;
};
// funcao principal que carrega todos
export function AvailableVehiclesFieldFormik({
  required = false,
  status = VEHICLE_STATUS.AVAILABLE,
  notRented = false,
  plan = "",
  partnerId,
  renterId,
  companyId,
  listAll = true,
}: Props) {
  const { setFieldValue } = useFormikContext();
  const [vehicles, setVehicles] = useState<
    (IVehicle & { label: string; _id: string })[]
  >([]);
  const [, setLoading] = useState(false);

  const loadOptions = async (input: string) => {
    setLoading(true);
    setVehicles([]);

    const fieldsToReceive =
      "_id,brand,model,licensePlate,odometerLocavibe,partnerInfo.companyName, createdAt, daysAtBase";
    const result = (await getVehiclesDebounced({
      itemsPerPage: 1000,
      search: input,
      fields: fieldsToReceive,
      partnerId: partnerId,
      renterId: renterId,
      companyId: companyId,
      listAll: listAll,
      status: notRented
        ? [
            VEHICLE_STATUS.AVAILABLE,
            VEHICLE_STATUS.UNDER_REVIEW,
            VEHICLE_STATUS.ADMINISTRATIVE_USE,
            VEHICLE_STATUS.IMPOUNDED,
            VEHICLE_STATUS.INACTIVE,
            VEHICLE_STATUS.INSURANCE,
            VEHICLE_STATUS.IN_REPAIR,
            VEHICLE_STATUS.IN_REVISION,
            VEHICLE_STATUS.MISSING_DATA,
            VEHICLE_STATUS.UNDEFINED,
            VEHICLE_STATUS.WAITING_PAYMENT,
            VEHICLE_STATUS.UNDER_PREPARATION,
            VEHICLE_STATUS.THIRD_PARTY_INSURANCE,
            VEHICLE_STATUS.TRIAGE,
          ]
        : status,
    })) as { ok: boolean; data: IVehicle[] };

    if (!result.ok) {
      setLoading(false);
      return [];
    }

    const filteredVehicles = filterVehiclesByPlan(result.data, plan);
    const options = filteredVehicles.map((item) => ({
      ...item,
      label: `${item.licensePlate} | ${formatCompanyName(
        item.partnerInfo?.companyName
      )}- ODO: ${item.odometerLocavibe} km |`,
      daysAtBase: item.daysAtBase || 0,
      _id: item._id,
    }));

    setVehicles(options);
    setLoading(false);
    return options;
  };

  useEffect(() => {
    const fetchOptions = async () => {
      await loadOptions("");
      setFieldValue("vehicle", null);
    };
    fetchOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plan]);

  return (
    <AutocompleteFormik
      name="vehicle"
      label="Veículo"
      options={vehicles}
      required={required}
      disableInvalidVehicles={true}
      exactMatchOnly={true}
    />
  );
}
